export default __webpack_public_path__ + "static/media/success.da9c1d0a.svg";